import axios from 'axios';

export const GET_UNPAID_AGENTS = '/unpaidAgents/getUnpaidAgents';
export const GET_UNPAID_AGENTS_EXCEL = '/unpaidAgents/getUnpaidAgentsForExcel';
export const SEND_MESSAGE = '/unpaidAgents/sendMessage';

export function getUnpaidAgents(queryParams, cancellationHandlers) {
  return axios.get(GET_UNPAID_AGENTS, {params: queryParams, ...cancellationHandlers});
}

export function getUnpaidAgentsFile(queryParams) {
  return axios.get(GET_UNPAID_AGENTS_EXCEL, {params: queryParams});
}

export function sendMessage(phone, email, message) {
  return axios.post(SEND_MESSAGE, {phone, email, message});
}